import RADApplication from '@/Management/RADApplication';

export default class UserSpecificData {
    constructor(optionalDisposable?: any) { }

    /**
     * Erstellt ein KO.Computed, welches mit UserSpecificData synchronisiert wird
     * @param key
     */
    static loadUserSpecificData<T>(key: string, defaultValue: T): KnockoutComputed<T> {
        return ko.computed({
            read: () => {
                let user = RADApplication.getInstance().user;
                if (!user.existUserSpecificData(key))
                    user.setUserSpecificData(key, defaultValue, true);

                return user.getUserSpecificData(key)();
            },
            write: (newValue) => {
                this.updateUserSpecificData(key, newValue);
            }
        });
    }

    private static updateUserSpecificData(key: string, newValue: any): void {
        // Bei ung�ltigem Key wird kein update gemacht
        if (String.isNullOrEmpty(key))
            return;

        let user = RADApplication.getInstance().user;

        // Bei leerem USD immer schreiben
        if (!user.existUserSpecificData(key))
            user.setUserSpecificData(key, newValue);

        // USD anpassen, wenn der wert ge�ndert wird
        let usdValue = user.getUserSpecificData(key)();
        if (!_.isEqual(newValue, usdValue))
            user.setUserSpecificData(key, newValue);
    }
}